
export * from './base';
export * from './login/login';
export * from './home/home';

export * from './history/history';
export * from './contact/contact';
export * from './scan/scan';
export * from './enteritem/enteritem';



// WEBPACK FOOTER //
// ./src/app/pages/index.ts